import { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Image, Spin, theme } from "antd";
import img from "../../assets/images/user.png";
import WithAuth from "../../hoc/WithAuth";
import { AuthContextValue, useAuth } from "../../providers/AuthProvider";
import { InfoCard } from "../../components/cards/info-card";
import { IoIosAdd } from "react-icons/io";
import { KeyRound } from "lucide-react";

const ProfilePage = () => {
  const { user } = useAuth() as AuthContextValue;
  const [file, setFile] = useState<File | null | undefined>(undefined);
  const [upload, setUpload] = useState(false);
  const [setTempImage] = useState<any>();

  const inputFile = useRef<HTMLInputElement>(null);

  if (!user) {
    return (
      <div style={{ display: "flex", justifyContent: "center", marginTop: 50 }}>
        <Spin size="large" />
      </div>
    );
  }
  const profileData = [
    {
      title: "Full Name",
      value: user.fullName,
    },
    {
      title: "Phone",
      value: user.phoneNo,
    },
    {
      title: "Email",
      value: (user as any).email,
    },
    {
      title: "Role",
      value: user.roleName,
    },
    {
      title: "User Name",
      value: user.userName,
    },
    {
      title: "Status",
      value: user.status === 1 ? "ACTIVE" : "INACTIVE",
      style: {
        borderRadius: 5,
        display: "flex",
        justifyContent: "center",
        width: 120,
        paddingTop: 6,
        paddingBottom: 6,
        fontWeight: 600,
        Radius: "5px",
        color: user.status === 1 ? "#065F46" : "#F44335",
        backgroundColor: `${user.status === 1 ? "#D1FAE5" : "#F44335"}44`,
      },
    },
  ];
  return (
    <div className="flex min-h-screen bg-white py-6 mt-2 gap-[200px]">
      <div className="w-[250px] h=[76px] border-0  p-6 pt-4 pb-6">
        <div className="px-6 pb-6 pt-6 w-[250px]">
          <div className="relative w-[200px] h-[200px] mx-auto">
            <Image
              preview={false}
              src={img}
              className="rounded-full"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />

            {!upload && (
              <IoIosAdd
                onClick={() => inputFile?.current?.click()}
                className="absolute bottom-2 right-2 text-[50px] text-[#128807]
                   bg-white rounded-full p-1 shadow-md cursor-pointer"
              />
            )}
          </div>

          <input
            type="file"
            ref={inputFile}
            style={{ display: "none" }}
            onChange={(e) => {
              if (e.target.files?.[0]) {
                setFile(e.target.files[0]);
                setTempImage(URL.createObjectURL(e.target.files[0]));
                setUpload(true);
              }
            }}
          />
        </div>

        <div className="px-6 ">
          <Link className="flex text-[#128807] " to={"/changePassword"}>
            {" "}
            <KeyRound className="w-6 h-6 mt-1 mr-1 " />
            <span className="text-gray-800 mt-1 hover:text-[#128807]">
              Change Password
            </span>
          </Link>
        </div>
      </div>
      <div className="flex justify-end p-2 space-y-8 pb-6 ">
        <section className="p-6 rounded-2xl border border-[#EBEBEB] gap-[10px] w-[698px] h-[198px] grid-cols-3 pb-60  ">
          <h2 className="text-base font-semibold text-[18px]  text-[#128807] mb-4 pt-2 pb-2">
            Personal Information
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 w-fit px-6 pb-6m pt-4 ">
            {profileData.map(
              (stat) =>
                stat && (
                  <InfoCard
                    className="text-[#128807]"
                    title={stat.title}
                    value={stat.value as any}
                    style={stat.style}
                  />
                )
            )}
          </div>
        </section>
      </div>
    </div>
  );
};

export default WithAuth(ProfilePage);
